var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex p-20 justify-content-center",
      attrs: { id: "stage-outer" },
    },
    [
      _vm.currentJob.getActiveStageJob().mainJob === null
        ? _c("upload-box")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-100 h-100", attrs: { id: "magic-stage" } },
        [
          _vm.currentJob.getActiveStageJob().mainJob?.apiJob?.output.length > 0
            ? _c("magic-canvas")
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }